 import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import LoadingFeedback from "../loadingFeedback";

const HighchartsComponent = ({ options, loading }) => {
   const chartKey = options?.chart?.type || "default";

  return (
    <LoadingFeedback loading={loading} variant="chart">
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      immutable
      key={chartKey}
    />
    </LoadingFeedback>
  );
};

export default HighchartsComponent;
